export enum FontSize {
  Title1 = 56,
  Title2 = 48,
  Subtitle1 = 32,
  Subtitle2 = 24,
  Label1 = 20,
  Label2 = 18,
  Description = 16,
  Body = 14,
  Caption1 = 12,
  Caption2 = 10,
}

export enum FontWeight {
  Light = 300,
  Regular = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
}

export enum FontFamily {
  Poppins = '"Poppins", sans-serif',
}

export const typography = {
  size: FontSize,
  weight: FontWeight,
  family: FontFamily,
}
